/* Wklejane zestawy: walidacja całego tekstu przed rozpoczęciem sprawdzania. */
(function (root) {
    'use strict';
    var MAX_ZESTAWOW = 20;

    function pula(tekst, maksimum, minimum, ile) {
        var tokeny = tekst.trim().split(/[\s,;]+/), liczby = [];
        for (var i = 0; i < tokeny.length; i++) {
            if (!/^\d+$/.test(tokeny[i])) { return { blad: 'znak', wartosc: tokeny[i] }; }
            var n = Number(tokeny[i]);
            if (n < 1 || n > maksimum) { return { blad: 'pula', wartosc: n, maksimum: maksimum }; }
            if (liczby.indexOf(n) !== -1) { return { blad: 'duplikat', wartosc: n }; }
            liczby.push(n);
        }
        if (liczby.length < minimum || liczby.length > ile) {
            return { blad: 'liczba', minimum: minimum, maksimum: ile, ile: liczby.length };
        }
        return { numbers: liczby.sort(function (a, b) { return a - b; }) };
    }

    function parsuj(tekst, reguly) {
        if (typeof tekst !== 'string' || !tekst.trim()) { return { blad: 'pusto' }; }
        if (tekst.length > 10000) { return { blad: 'limit', maksimum: MAX_ZESTAWOW }; }
        var wiersze = tekst.split(/\r\n|\n|\r/), zestawy = [];
        for (var i = 0; i < wiersze.length; i++) {
            if (!wiersze[i].trim()) { continue; }
            if (zestawy.length === MAX_ZESTAWOW) { return { blad: 'limit', maksimum: MAX_ZESTAWOW }; }
            var czesci = wiersze[i].split('+'), dodatkowe = reguly.extraCount > 0;
            if (czesci.length !== (dodatkowe ? 2 : 1) || czesci.some(function (s) { return !s.trim(); })) {
                return { blad: dodatkowe ? 'euro' : 'znak', wiersz: i + 1, wartosc: '+' };
            }
            var g = pula(czesci[0], reguly.pool, reguly.min, reguly.max);
            if (g.blad) { g.wiersz = i + 1; return g; }
            var s = dodatkowe ? pula(czesci[1], reguly.extraPool, reguly.extraCount, reguly.extraCount) : { numbers: [] };
            if (s.blad) { s.wiersz = i + 1; s.euro = true; return s; }
            zestawy.push({ numbers: g.numbers, extra: s.numbers, wiersz: i + 1 });
        }
        return { zestawy: zestawy };
    }

    var api = { parsuj: parsuj, MAX_ZESTAWOW: MAX_ZESTAWOW };
    if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
    else { root.PewniakiWklejane = api; }
})(typeof window !== 'undefined' ? window : this);
